import React from "react"
import PropTypes from "prop-types"
import Layout from "../Layout"

const DealGroupView = (props) => {
  return <Layout {...props} type="DealGroupView" />
}

DealGroupView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func,
}
export default DealGroupView



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/DealGroupView.js